<div class="dropdown">
  <button type="button" class="btn btn-sm btn-light dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
    <span class="uil-print"></span>
  </button>
  @for (group of groupKeys; track group) {
    <div class="dropdown-menu dropdown-menu-end">
      <h6 class="dropdown-header">{{group | titlecase}}</h6>
      @for (form of formKeys(group); track form) {
        <a class="dropdown-item clickable" [title]="revision(group, form)" (click)="view(group, form)">{{form}}</a>
      }
    </div>
  }
</div>


<!-- Pdf View Modal -->
<button id="btn-view-pdf-modal-drop-down" data-target="#pdfViewModal-drop-down" data-toggle="modal" class="btn btn-sm d-none"></button>
<div id="pdfViewModal-drop-down" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="pdfViewModal-drop-down">
  <div class="modal-dialog modal-full-width modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Forms</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body p-1">
        @if (pdf) {
          <object type="application/pdf" [data]="pdf" width="100%" height="90%"></object>
        }
      </div>
    </div>
  </div>
</div>